const allProducts = [
  {
    id: 1,
    name: "Tallai Bag",
    price: 13600,
    prevPrice: 17900,
    description:
      " Tallai features a polyester construction with synthetic trim so you can make it to the xext class in time. This product may have a manufacturer's warranty. please visit the manufacturer's website or contact us at mbclothing@gmail.com for full manufacturers warranty details",
    category: "Bags",
    image: require("../assets/img/bag1.jpg"),
    selected: false
  },
  {
    id: 2,
    name: "Jonny Mat Bag",
    price: 11400,
    prevPrice: 14820,
    description:
      " Jonny Mat features a polyester construction with synthetic trim so you can make it to the xext class in time. This product may have a manufacturer's warranty. please visit the manufacturer's website or contact us at mbclothing@gmail.com for full manufacturers warranty details",
    category: "Bags",
    image: require("../assets/img/bag2.jpg"),
    selected: false
  },
  {
    id: 3,
    name: "Gabinci Bag",
    price: 18200,
    prevPrice: 20500,
    description:
      " Gabinci Bag features a polyester construction with synthetic trim so you can make it to the xext class in time. This product may have a manufacturer's warranty. please visit the manufacturer's website or contact us at mbclothing@gmail.com for full manufacturers warranty details",
    category: "Bags",
    image: require("../assets/img/bag3.jpg"),
    selected: false
  },
  {
    id: 4,
    name: "Champ Manuscript Bag",
    price: 14700,
    prevPrice: 17500,
    description:
      " Champ Manuscript features a polyester construction with synthetic trim so you can make it to the xext class in time. This product may have a manufacturer's warranty. please visit the manufacturer's website or contact us at mbclothing@gmail.com for full manufacturers warranty details",
    category: "Bags",
    image: require("../assets/img/bag4.jpg"),
    selected: false
  },
  {
    id: 5,
    name: "Skilina Bag",
    price: 38000,
    prevPrice: 40600,
    description:
      " Skilina features a polyester construction with synthetic trim so you can make it to the xext class in time. This product may have a manufacturer's warranty. please visit the manufacturer's website or contact us at mbclothing@gmail.com for full manufacturers warranty details",
    category: "Bags",
    image: require("../assets/img/bag5.jpg"),
    selected: false
  },
  {
    id: 6,
    name: "Oakley Bag",
    price: 6900,
    prevPrice: 5300,
    description:
      " Oakley features a polyester construction with synthetic trim so you can make it to the xext class in time. This product may have a manufacturer's warranty. please visit the manufacturer's website or contact us at mbclothing@gmail.com for full manufacturers warranty details",
    category: "Bags",
    image: require("../assets/img/bag3.jpg"),
    selected: false
  },
  {
    id: 7,
    name: "Allen Edmonds Belt",
    price: 1300,
    prevPrice: 2900,
    description:
      " Allen Edmonds add layer of luxury to its handsome silhouette. Gold-tone single prong buckle closure. single letter, spot clean, made in Italy. Product measurements were taking using size 8.5, width D - medium. Please note that measurement may vary by size!",
    category: "Belt",
    image: require("../assets/img/belt1.jpg"),
    selected: false
  },
  {
    id: 8,
    name: "Torino Leather Belt",
    price: 1400,
    prevPrice: 1820,
    description:
      " Torino Leather belt show your off with beautifully detailed and crafted belt. Gold-tone single prong buckle closure. single letter, spot clean, made in Italy. Product measurements were taking using size 8.5, width D - medium. Please note that measurement may vary by size!",
    category: "Belt",
    image: require("../assets/img/belt2.jpg"),
    selected: false
  },
  {
    id: 9,
    name: "Cole Haan Belt",
    price: 2200,
    prevPrice: 3400,
    description:
      " Bring something new to the mix with Cole Haan. Gold-tone single prong buckle closure. single letter, spot clean, made in Italy. Product measurements were taking using size 8.5, width D - medium. Please note that measurement may vary by size!",
    category: "Belt",
    image: require("../assets/img/belt3.jpg"),
    selected: false
  },
  {
    id: 10,
    name: "ADA Tough Belt",
    price: 2700,
    prevPrice: 3500,
    description:
      " ADA Tough belt show your off with beautifully detailed and crafted belt. Gold-tone single prong buckle closure. single letter, spot clean, made in Italy. Product measurements were taking using size 8.5, width D - medium. Please note that measurement may vary by size!",
    category: "Belt",
    image: require("../assets/img/belt4.jpg"),
    selected: false
  },

  {
    id: 11,
    name: "Mavi Black Shoes",
    price: 12000,
    prevPrice: 10300,
    description:
      " Add classic styling to your dinner-date ensemble waering the faux-leather Mavi Black Shoe. Smooth man-made lining with a cushioned footbed for added comfort. It is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using size 8.5, width D - medium. Please note that measurement may vary by size",
    category: "Shoes",
    image: require("../assets/img/shoe1.jpg"),
    selected: false
  },
  {
    id: 12,
    name: "Gabby Ransom Shoe",
    price: 12800,
    prevPrice: 16900,
    description:
      "Gabby Ransom shoes adds classic styling to your dinner-date ensemble wearing the faux-leather, wrapped heel female. Add a classic oxford style to your office wardrobe with the handsome faux-leather Xally Shoe. Smooth man-made lining with a cushioned footbed for added comfort. It is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using size 8.5, width D - medium. Please note that measurement may vary by size.",
    category: "Shoes",
    image: require("../assets/img/lshoe1.jpg"),
    selected: false
  },
  {
    id: 13,
    name: "Gabby Ransom Set",
    price: 71400,
    prevPrice: 88100,
    description:
      " Gabby Ransom set are regular rise and straight sets that is crafted in an ultra-soft, premium stretch fabrication. It's crafted in an incredibly soft and comfortable denim fabrication, and features a medium wash with just enough fading for authentic worn-in look. Matt is ideal for man seeking a relaxed rise in versatile straight leg. Product measurements were taken using size 32. Please note than measurements may vary by size",
    category: "Suit",
    image: require("../assets/img/mw3.jpg"),
    selected: false
  },
  {
    id: 14,
    name: "Shoddi Top",
    price: 15200,
    prevPrice: 17400,
    description:
      "Shoddi white top is crafted in an ultra-soft, premium stretch fabrication. You'll clean up nicely with the Rosidi White top. Cotton construction for all-day comfort. short sleeves, and a straight hemline secure a classic look. it is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using size 32. Please note that measurement may vary by size.",
    category: "Ladies",
    image: require("../assets/img/ltop5.jpg"),
    selected: false
  },
  {
    id: 15,
    name: "Magnol Black Top",
    price: 7000,
    prevPrice: 9900,
    description:
      " Magnol Black top adds classic styling to your dinner-date ensemble wearing the. Cotton construction for all-day comfort. short sleeves, and a straight hemline secure a classic look. it is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using size 32. Please note that measurement may vary by size.",
    category: "Ladies",
    image: require("../assets/img/ltop1.jpg"),
    selected: false
  },
  {
    id: 16,
    name: "Vera Zach Shoe",
    price: 7000,
    prevPrice: 9400,
    description:
      " Vera Zach shoes adds classic styling to your dinner-date ensemble wearing the faux-leather, wrapped heel female Vera Shoe. Smooth man-made lining with a cushioned footbed for added comfort. It is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using size 8.5, width D - medium. Please note that measurement may vary by size.",
    category: "Shoes",
    image: require("../assets/img/lshoe7.jpg"),
    selected: false
  },
  {
    id: 17,
    name: "Rosidi Top",
    price: 13000,
    prevPrice: 14400,
    description:
      " You'll clean up nicely with the Rosidi top. Cotton construction for all-day comfort. short sleeves, and a straight hemline secure a classic look. it is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using size 32. Please note that measurement may vary by size.",
    category: "Ladies",
    image: require("../assets/img/ltop3.jpg"),
    selected: false
  },
  {
    id: 18,
    name: "Dawet Heel",
    price: 7000,
    prevPrice: 8200,
    description:
      "Dawet Heel are regular rise and straight sets that is crafted in an ultra-soft, premium stretch fabrication .Add classic styling to your dinner-date ensemble wearing the faux-leather, wrapped heel female Dawet Heel Shoe. Smooth man-made lining with a cushioned footbed for added comfort. It is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using size 8.5, width D - medium. Please note that measurement may vary by size.",
    category: "Shoes",
    image: require("../assets/img/lshoe3.jpg"),
    selected: false
  },
  {
    id: 19,
    name: "xally set",
    price: 7600,
    prevPrice: 8900,
    description:
      " Xally set are regular rise and straight sets that is crafted in an ultra-soft, premium stretch fabrication. It's crafted in an incredibly soft and comfortable denim fabrication, and features a medium wash with just enough fading for authentic worn-in look. Matt is ideal for man seeking a relaxed rise in versatile straight leg. Product measurements were taken using size 32. Please note than measurements may vary by size.",
    category: "Ladies",
    image: require("../assets/img/tp3.jpg"),
    selected: false
  },
  {
    id: 20,
    name: "Pezusi Set",
    price: 11000,
    prevPrice: 13400,
    description:
      " The Pezusi set is crafted in an incredibly soft and comfortable denim fabrication, and features a medium wash with just enough fading for authentic worn-in look. Matt is ideal for man seeking a relaxed rise in versatile straight leg. Product measurements were taken using size 32. Please note than measurements may vary by size.",
    category: "Suit",
    image: require("../assets/img/Msute2.jpg"),
    selected: false
  },
  {
    id: 21,
    name: "Mavi Fits Jeans",
    price: 11800,
    prevPrice: 13900,
    description:
      " Mavi fits jeans are soft and comfortable, they are destined to become your favorite. It's crafted in an incredibly soft and comfortable denim fabrication, and features a medium wash with just enough fading for authentic worn-in look. Matt is ideal for man seeking a relaxed rise in versatile straight leg. Product measurements were taken using size 32. Please note than measurements may vary by size.",
    category: "Jeans",
    image: require("../assets/img/jeans5.jpg"),
    selected: false
  },
  {
    id: 22,
    name: "Magnolis Jeans",
    price: 14000,
    prevPrice: 15100,
    description:
      " The Magnolis Jeans is crafted in an incredibly soft and comfortable denim fabrication, and features a medium wash with just enough fading for authentic worn-in look. Matt is ideal for man seeking a relaxed rise in versatile straight leg. Product measurements were taken using size 32. Please note than measurements may vary by size.",
    category: "Jeans",
    image: require("../assets/img/jeans3.jpg"),
    selected: false
  },
  {
    id: 23,
    name: "Hudson James Jean",
    price: 9400,
    prevPrice: 10100,
    description:
      " These stylish and comfortable Hudson Jean will be on heavy rotation in your weekly wardrobe. It's crafted in an incredibly soft and comfortable denim fabrication, and features a medium wash with just enough fading for authentic worn-in look. Matt is ideal for man seeking a relaxed rise in versatile straight leg. Product measurements were taken using size 32. Please note than measurements may vary by size.",
    category: "Jeans",
    image: require("../assets/img/jeans4.jpg"),
    selected: false
  },
  {
    id: 24,
    name: "363 Vintage Jean",
    price: 12000,
    prevPrice: 13500,
    description:
      " The 363 Vintage straight is the newer, updated version of the 361 Vintage Straight. It's crafted in an incredibly soft and comfortable denim fabrication, and features a medium wash with just enough fading for authentic worn-in look. Matt is ideal for man seeking a relaxed rise in versatile straight leg. Product measurements were taken using size 32. Please note than measurements may vary by size.",
    category: "Jeans",
    image: require("../assets/img/jeans2.jpg"),
    selected: false
  },
  {
    id: 25,
    name: "Buffalo David Bitton Jean",
    price: 17000,
    prevPrice: 20400,
    description:
      " For effortless everyday outfits, nothinh beats the buffalo Davids Bitton Jean. It's crafted in an incredibly soft and comfortable denim fabrication, and features a medium wash with just enough fading for authentic worn-in look. Matt is ideal for man seeking a relaxed rise in versatile straight leg. Product measurements were taken using size 32. Please note than measurements may vary by size.",
    category: "Jeans",
    image: require("../assets/img/jeans1.jpg"),
    selected: false
  },
  {
    id: 26,
    name: "Mavi Matt Mid-Rise",
    price: 9700,
    prevPrice: 10900,
    description:
      " The Mavi Matt Mid-Rise Relaxed Straight in Mid Brushed Cashmere is a versatile jean you'll want to wear every day. It's crafted in an incredibly soft and comfortable denim fabrication, and features a medium wash with just enough fading for authentic worn-in look. Matt is ideal for man seeking a relaxed rise in versatile straight leg. Product measurements were taken using size 32. Please note than measurements may vary by size.",
    category: "Jeans",
    image: require("../assets/img/jeans1.jpg"),
    selected: false
  },
  {
    id: 27,
    name: "Vans kids Houser",
    price: 5800,
    prevPrice: 7200,
    description:
      " You'll clean up nicely with the Vans Kids Houser top. Cotton construction for all-day comfort. short sleeves, and a straight hemline secure a classic look. it is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using 4 little kids. Please note that measurement may vary by size.",
    category: "Kids",
    image: require("../assets/img/bb1.jpg"),
    selected: false
  },
  {
    id: 28,
    name: "Joules Kids Sark",
    price: 5700,
    prevPrice: 5100,
    description:
      " In the Joules Kids Short sleeve button-up shirt he's sure to look and feel his best. short sleeves, and a straight hemline secure a classic look. it is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using 4 little kids. Please note that measurement may vary by size.",
    category: "Kids",
    image: require("../assets/img/bb2.jpg"),
    selected: false
  },
  {
    id: 29,
    name: "Tommy Hilfiger Wear",
    price: 9400,
    prevPrice: 10100,
    description:
      " Dress him to impress in Tommy Hilfiger forest button-down shirt. short sleeves, and a straight hemline secure a classic look. it is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using 4 little kids. Please note that measurement may vary by size.",
    category: "Kids",
    image: require("../assets/img/bb3.jpg"),
    selected: false
  },
  {
    id: 30,
    name: "Givenchy Wear",
    price: 10200,
    prevPrice: 13500,
    description:
      " A flattering icon, this converse Kids T-shirt is a great hit for jeans! Round neckline, short sleeves, and a straight hemline secure a classic look. it is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using 4 little kids. Please note that measurement may vary by size.",
    category: "Kids",
    image: require("../assets/img/bb5.jpg"),
    selected: false
  },
  {
    id: 31,
    name: "OshKosh Kids Wear",
    price: 6000,
    prevPrice: 6500,
    description:
      " Oshkosh cute adds a touch to your look. Cotton knit features a three button closure with brand detail front . It is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using 4 little kids. Please note that measurement may vary by size.",
    category: "Kids",
    image: require("../assets/img/bb6.jpg"),
    selected: false
  },
  {
    id: 32,
    name: "Peplum Tunic Wear",
    price: 4800,
    prevPrice: 7500,
    description:
      " Her outlook style is sure to make a statement with the Peplum Tunic. It is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using 4 little kids. Please note that measurement may vary by size.",
    category: "Kids",
    image: require("../assets/img/bb7.jpg"),
    selected: false
  },
  {
    id: 33,
    name: "Santina Zero Shoes",
    price: 8800,
    prevPrice: 11900,
    description:
      " Leather detailing and a reflective pull tab give the Santina Zero shoe a retro touch. Smooth man-made lining with a cushioned footbed for added comfort. It is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using size 8.5, width D - medium. Please note that measurement may vary by size.",
    category: "Shoes",
    image: require("../assets/img/mshoe1.jpg"),
    selected: false
  },
  {
    id: 34,
    name: "Gabby Shoes",
    price: 5400,
    prevPrice: 8100,
    description:
      " Whether you-re helping customers or behind the sences, take care of the business in the Gabby Avi-skill shoe. Smooth man-made lining with a cushioned footbed for added comfort. It is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using size 8.5, width D - medium. Please note that measurement may vary by size.",
    category: "Shoes",
    image: require("../assets/img/mshoe2.jpg"),
    selected: false
  },
  {
    id: 35,
    name: "Shoddi Shoes",
    price: 15200,
    prevPrice: 17400,
    description:
      " Shoddi Ralph sampson sport a low-top old school design in a leather upper to keep you look fresh this season. Smooth man-made lining with a cushioned footbed for added comfort. It is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using size 8.5, width D - medium. Please note that measurement may vary by size.",
    category: "Shoes",
    image: require("../assets/img/mshoe3.jpg"),
    selected: false
  },
  {
    id: 36,
    name: "Magnol Shoe",
    price: 7000,
    prevPrice: 9900,
    description:
      " Magnol classic features a knit upper with syntheic overlays and a branded elastic strap accross the vamp. Smooth man-made lining with a cushioned footbed for added comfort. It is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using size 8.5, width D - medium. Please note that measurement may vary by size.",
    category: "Shoes",
    image: require("../assets/img/mshoe4.jpg"),
    selected: false
  },
  {
    id: 37,
    name: "Vera Tamika Shoe",
    price: 17000,
    prevPrice: 20400,
    description:
      " Add classic styling to your dinner-date ensemble wearing the faux-leather, wrapped heel female Vera Tamika Shoe. Smooth man-made lining with a cushioned footbed for added comfort. It is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using size 8.5, width D - medium. Please note that measurement may vary by size.",
    category: "Shoes",
    image: require("../assets/img/mshoe5.jpg"),
    selected: false
  },
  {
    id: 38,
    name: "Rosidi Shoe",
    price: 13000,
    prevPrice: 14400,
    description:
      " Rosidi Classic is a nice casual look that you can take with you anywhere!. Man-made upper. Smooth man-made lining with a cushioned footbed for added comfort. It is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using size 8.5, width D - medium. Please note that measurement may vary by size.",
    category: "Shoes",
    image: require("../assets/img/mshoe6.jpg"),
    selected: false
  },
  {
    id: 39,
    name: "xally Shoe",
    price: 7600,
    prevPrice: 8900,
    description:
      " Add a classic oxford style to your office wardrobe with the handsome faux-leather Xally Shoe. Smooth man-made lining with a cushioned footbed for added comfort. It is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using size 8.5, width D - medium. Please note that measurement may vary by size.",
    category: "Shoes",
    image: require("../assets/img/mshoe8.jpg"),
    selected: false
  },
  {
    id: 40,
    name: "Pezusi Shoe",
    price: 11000,
    prevPrice: 13400,
    description:
      " Featuring vamp goring, easily access a handsome office style wearing the faux-leather Pezusi Shoe. Smooth man-made lining with a cushioned footbed for added comfort. It is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using size 8.5, width D - medium. Please note that measurement may vary by size.",
    category: "Shoes",
    image: require("../assets/img/mshoe9.jpg"),
    selected: false
  },
  {
    id: 41,
    name: "Tommy Hilfiger Black Shoes",
    price: 12000,
    prevPrice: 10300,
    description:
      " Add classic styling to your dinner-date ensemble waering the faux-leather Tommy Hilfiger Black Shoe. Smooth man-made lining with a cushioned footbed for added comfort. It is durable synthetic outsole, imported and  signature pony player. Product measurements were taking using size 8.5, width D - medium. Please note that measurement may vary by size.",
    category: "Shoes",
    image: require("../assets/img/shoe1.jpg"),
    selected: false
  },
  {
    id: 42,
    name: "Santina T-shirt",
    price: 12800,
    prevPrice: 16900,
    description:
      " Take your ensemble up a style notch with Santina Laurne T-shirt. This soft, lightweight and cool t-shirt is not only a stylish stale but it's also a washable knit. It is machine wash, dry flat, imported, signature pony player. Product measurements were taking using size MD. Please note that measurement may vary by size.",
    category: "T-shirt",
    image: require("../assets/img/tshirt1.jpg"),
    selected: false
  },
  {
    id: 43,
    name: "Gabby T-shirt",
    price: 51400,
    prevPrice: 58100,
    description:
      " Gabby T-shirt offers comfort and style. This soft, lightweight and cool t-shirt is not only a stylish stale but it's also a washable knit. It is machine wash, dry flat, imported, signature pony player. Product measurements were taking using size MD. Please note that measurement may vary by size.",
    category: "T-shirt",
    image: require("../assets/img/tshirt2.jpg"),
    selected: false
  },
  {
    id: 44,
    name: "Shoddi T-shirt",
    price: 15200,
    prevPrice: 17400,
    description:
      " Keeing your look simple and comfortable just easier wearing Shoddi T-shirt. This soft, lightweight and cool t-shirt is not only a stylish stale but it's also a washable knit. It is machine wash, dry flat, imported, signature pony player. Product measurements were taking using size MD. Please note that measurement may vary by size.",
    category: "T-shirt",
    image: require("../assets/img/tshirt3.jpg"),
    selected: false
  },
  {
    id: 45,
    name: "Magnol T-shirt",
    price: 7000,
    prevPrice: 9900,
    description:
      " Add a nautical touch to any look in the classic ans casual appeal of this Magnol T-shirt. This soft, lightweight and cool t-shirt is not only a stylish stale but it's also a washable knit. It is machine wash, dry flat, imported, signature pony player. Product measurements were taking using size MD. Please note that measurement may vary by size.",
    category: "T-shirt",
    image: require("../assets/img/tshirt4.jpg"),
    selected: false
  },
  {
    id: 46,
    name: "Vera T-shirt",
    price: 17000,
    prevPrice: 20400,
    description:
      " Move with confidence in this classically handsome Vera T-shirt. This soft, lightweight and cool t-shirt is not only a stylish stale but it's also a washable knit. It is machine wash, dry flat, imported, signature pony player. Product measurements were taking using size MD. Please note that measurement may vary by size.",
    category: "T-shirt",
    image: require("../assets/img/clothes1.jpg"),
    selected: false
  },
  {
    id: 47,
    name: "Rosidi T-shirt",
    price: 13000,
    prevPrice: 14400,
    description:
      " Add 'well-dressed' to your reputation in this sleek Rosidi T-shirt. This soft, lightweight and cool t-shirt is not only a stylish stale but it's also a washable knit. It is machine wash, dry flat, imported, signature pony player. Product measurements were taking using size MD. Please note that measurement may vary by size.",
    category: "T-shirt",
    image: require("../assets/img/pick2.jpg"),
    selected: false
  },
  {
    id: 48,
    name: "Dawet T-shirt",
    price: 7000,
    prevPrice: 8200,
    description:
      " Keep your style on point wearing the cotton-blend Dawet T-shirt. This soft, lightweight and cool t-shirt is not only a stylish stale but it's also a washable knit. It is machine wash, dry flat, imported, signature pony player. Product measurements were taking using size MD. Please note that measurement may vary by size.",
    category: "T-shirt",
    image: require("../assets/img/pick3.jpg"),
    selected: false
  },
  {
    id: 49,
    name: "xally T-shirt",
    price: 7600,
    prevPrice: 8900,
    description:
      " If it's comfortable and casual style you are loking forward, look no further than the handsome Xally T-shirt. This soft, lightweight and cool t-shirt is not only a stylish stale but it's also a washable knit. It is machine wash, dry flat, imported, signature pony player. Product measurements were taking using size MD. Please note that measurement may vary by size.",
    category: "T-shirt",
    image: require("../assets/img/tp3.jpg"),
    selected: false
  },
  {
    id: 50,
    name: "Pezusi T-shirt",
    price: 11000,
    prevPrice: 13400,
    description:
      " Dress it up or down in this Pezusi T-shirt. This soft, lightweight and cool t-shirt is not only a stylish stale but it's also a washable knit. It is machine wash, dry flat, imported, signature pony player. Product measurements were taking using size MD. Please note that measurement may vary by size.",
    category: "T-shirt",
    image: require("../assets/img/mw1.jpg"),
    selected: false
  },
  {
    id: 51,
    name: "Marina T-Shirt",
    price: 13100,
    prevPrice: 11100,
    description:
      " When you're finally done with humanity and decide to grow out your beard, but axe, and retreat into the deep woods as a solitary recluse, this Marina T-shirt will certainly come in handy. This soft, lightweight and cool t-shirt is not only a stylish stale but it's also a washable knit. It is machine wash, dry flat, imported, signature pony player. Product measurements were taking using size MD. Please note that measurement may vary by size.",
    category: "T-shirt",
    image: require("../assets/img/tshirt2.jpg"),
    selected: false
  }
];

export default {
  getAllProducts() {
    return allProducts;
  }
};
